import { OutagesPanel } from '@/features/outages/OutagesPanel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/outages')({
  component: OutagesPanel,
});
